export default "__VITE_ASSET__C3vYv9T9__"